import"../../chunk-SDBWQ4EE.js";const n=t=>`${t||""}${Date.now().toString(36)+Math.random().toString(36).substring(2)}`;export{n as uuid};
